import React, { Fragment, useState, useEffect, useContext } from "react";
import { Context } from "../../themeContext";

import { PencilIcon, XCircleIcon } from "@heroicons/react/solid";
import axios from "axios";
import {
  Home,
  Users,
  Clock,
  BookOpen,
  Voicemail,
  BarChart2,
  CornerLeftDown,
} from "react-feather";
import { ArrowDownLeft } from "react-feather";
import ReactDOM from "react-dom";
import { PlusIcon } from "@heroicons/react/solid";
import Modalchoix from "./renvoiinterne/Modalchoix";
import Renvoidirect from "./renvoidirect/Renvoidirect";
import Deleterenvoidirect from "./renvoidirect/Deleterenvoidirect";
import Deleterenvoiinterne from "./renvoiinterne/Deleterenvoiinterne";
import { withTranslation } from "react-i18next";

import Editrenvoidirect from "./renvoidirect/Editrenvoidirect";
import Editrenvoiinterne from "./renvoiinterne/Editrenvoiinterne";
import Editrenvoiexterne from "./renvoiexterne/Editrenvoiexterne";
import Deleterenvoiexterne from "./renvoiexterne/Deleterenvoiexterne";
import Modalchoixexterne from "./renvoiexterne/Modalchoixexterne";
import "./style.css";
import { propTypes } from "react-bootstrap/esm/Image";
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
function Profile2(props) {
  const { t, tReady } = props;
  const [state, dispatch] = useContext(Context);

  /////////////////////////modal add interne /////////////:
  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  /////////////////////////:modél add renvoi direcht
  const [showModalrenvoi, setShowrenvoi] = useState(false);
  const handleCloserenvoi = () => setShowrenvoi(false);
  const handleShowrenvoi = () => setShowrenvoi(true);

  //////////////////////delete renvoi direct  modal /////////////////////
  const [showdeleteModalrenvoi, setShowdeleterenvoi] = useState(false);
  const handleClosedeleterenvoi = () => setShowdeleterenvoi(false);
  const handleShowdeleterenvoi = () => setShowdeleterenvoi(true);

  //////////////////////////////////////////////////////////////////
  //////////////////////edit renvoi direct  modal /////////////////////
  const [showeditModalrenvoi, setShoweditrenvoi] = useState(false);
  const handleCloseeditrenvoi = () => setShoweditrenvoi(false);
  const handleShoweditrenvoi = () => setShoweditrenvoi(true);

  ///////////////////////////renvoi direct///////////////////////////////////////
  const [renvoidirect, setRenvoidirect] = useState(false);
  const [renvoidirectnum, setRenvoidirectnum] = useState("");
  //////////////////////////////////////////////////////////////////////::::

  ///////////////////////////renvoi interne///////////////////////////////////////
  const [renvoiinternetype, setRenvoiinternetype] = useState("");
  const [renvoiinterne, setRenvoiinterne] = useState(false);
  const [renvoiinternenum, setRenvoiinternenum] = useState("");
  const [renvoiinternesonnerie, setrenvoiinternesonnerie] = useState("");

  //////////////////////////////////////////////////////////////////////::::
  //////////////////////delete renvoi interne  modal /////////////////////
  const [showdeleteModal_renvoi_interne, setShowdelete_renvoi_interne] =
    useState(false);
  const handleClosedelete_renvoi_interne = () =>
    setShowdelete_renvoi_interne(false);
  const handleShowdelete_renvoi_interne = () =>
    setShowdelete_renvoi_interne(true);

  //////////////////////////////////////////////////////////////////
  //////////////////////edit renvoi interne  modal /////////////////////
  const [showeditModal_renvoi_interne, setShowedit_renvoi_interne] =
    useState(false);
  const handleCloseedit_renvoi_interne = () =>
    setShowedit_renvoi_interne(false);
  const handleShowedit_renvoi_interne = () => setShowedit_renvoi_interne(true);

  //////////////////////////////////////////////////////////////////
  ///////////////////////////renvoi externe///////////////////////////////////////
  const [renvoiexternetype, setRenvoiexternetype] = useState("");
  const [renvoiexterne, setRenvoiexterne] = useState(false);
  const [renvoiexternenum, setRenvoiexternenum] = useState("");
  const [renvoiexternesonnerie, setrenvoiexternesonnerie] = useState("");

  //////////////////////////////////////////////////////////////////////::::
  //////////////////////delete renvoi externe  modal /////////////////////
  const [showdeleteModal_renvoi_externe, setShowdelete_renvoi_externe] =
    useState(false);
  const handleClosedelete_renvoi_externe = () =>
    setShowdelete_renvoi_externe(false);
  const handleShowdelete_renvoi_externe = () =>
    setShowdelete_renvoi_externe(true);

  //////////////////////////////////////////////////////////////////
  //////////////////////edit renvoi externe  modal /////////////////////
  const [showeditModal_renvoi_externe, setShowedit_renvoi_externe] =
    useState(false);
  const handleCloseedit_renvoi_externe = () =>
    setShowedit_renvoi_externe(false);
  const handleShowedit_renvoi_externe = () => setShowedit_renvoi_externe(true);

  //////////////////////////////////////////////////////////////////
  /////////////////////////:modél add renvoi externe
  const [showModalexterne, setShowexterne] = useState(false);
  const handleCloseexterne = () => setShowexterne(false);
  const handleShowexterne = () => setShowexterne(true);

  const fetchData = async () => {
    var lien = window.location.href;

    const var2 = lien.split("/");

    var var4 = var2[2].split(":");

    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = await axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EtatRenvoiDirectIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        if (res.data.etat_ws == "activer") {
          setRenvoidirect(true);
          setRenvoidirectnum(res.data.tel_renvoi);
          // var data = "renvoidirect";
          dispatch({ type: "SET_Renvoi_direct" });
        } else {
          setRenvoidirect(false);
          dispatch({ type: "DEL_Renvoi_direct" });
        }
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const fetchDataexterne = async () => {
    var lien = window.location.href;

    const var2 = lien.split("/");

    var var4 = var2[2].split(":");

    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = await axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EtatRenvoiInjoignabiliterExterneIPBXV3API?compte=${compte}&poste=${poste}`,

        config
      )
      .then((res) => {
        if (res.data.etat_renvoi == "activer") {
          // var data = "renvoiexterne";

          setRenvoiexterne(true);
          setRenvoiexternenum(res.data.default_destination_externe);
          setrenvoiexternesonnerie(res.data.nb_sonnerie);
          switch (res.data.default_action_externe) {
            case "1":
              setRenvoiexternetype("Poste interne");
              dispatch({ type: "SET_Renvoi_externe" });
              break;
            case "2":
              setRenvoiexternetype("Boite vocale");
              break;
            case "10":
              setRenvoiexternetype("Mobile");
              dispatch({ type: "SET_Renvoi_externe" });
              break;
            default:
              setRenvoiexternetype("");
          }
        } else {
          setRenvoiexterne(false);
          dispatch({ type: "DEL_Renvoi_externe" });
        }
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const fetchDatainterne = async () => {
    var lien = window.location.href;

    const var2 = lien.split("/");

    var var4 = var2[2].split(":");

    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = await axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EtatRenvoiInjoignabiliterInterneIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        if (res.data.etat_renvoi == "activer") {
          setRenvoiinterne(true);
          setRenvoiinternenum(res.data.default_destination);
          setrenvoiinternesonnerie(res.data.nb_sonnerie);
          switch (res.data.default_action) {
            case "1":
              setRenvoiinternetype("Poste interne");
              dispatch({ type: "SET_Renvoi_interne" });
              break;
            case "2":
              setRenvoiinternetype("Boite vocale");
              break;
            case "10":
              setRenvoiinternetype("Mobile");
              dispatch({ type: "SET_Renvoi_interne" });
              break;
            default:
              setRenvoiinternetype("");
          }
        } else {
          setRenvoiinterne(false);
          dispatch({ type: "DEL_Renvoi_interne" });
        }
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  useEffect(() => {
    fetchData();
    fetchDatainterne();
    fetchDataexterne();
  }, []);
  return (
    <div className="min-h-screen w-full  bg-white flex dark:bg-gray-700 bg-gray-200 ">
      <div className="  space-y-8 divide-y divide-gray-200 sm:space-y-5 w-full pl-20 dark:bg-gray-800 bg-white shadow sm:rounded-md sm:overflow-hidden mr-8">
        <div>
          <div className="flex">
            <h2 className="dark:text-white pb-8 pt-4 text-lg leading-6 mt-2 my-2 mx-2 font-medium text-gray-900">
              {" "}
              {t("transfert.appel.titre")}{" "}
            </h2>
            {renvoidirect || renvoiinterne || renvoiexterne == true ? (
              <p> </p>
            ) : (
              <h2 className="dark:text-white pb-8 pt-4 text-lg leading-6 mt-2 my-2 mx-2 font-medium text-gray-900">
                : {t("conf.actuel")}{" "}
              </h2>
            )}
          </div>
          <div className="justify-center flex ">
            <div className="row-span-2 col-span-2 ">
              <span className="relative z-0 inline-flex shadow-sm rounded-md mt-8 -ml-48 mb-4">
                <button
                  type="button"
                  className="dark:text-white dark:bg-gray-700 relative inline-flex items-center px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    style={{ color: "rgba(5,150,105,var(--tw-text-opacity))" }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                    />
                  </svg>
                  {t("transfert.appel.appel.entrant")}
                </button>
              </span>
            </div>
          </div>{" "}
          <div className="justify-center flex -ml-72 h-16">
            <div className="mx-32">
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-arrow-down-left"
              >
                <line x1="20" y1="4" x2="4" y2="20"></line>
                <polyline points="10 17 7 17 7 14"></polyline>
              </svg> */}

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                fill="currentColor"
                class="bi bi-arrow-down-left"
                viewBox="0 0 16 16"
                style={{ color: "#666a6f" }}
              >
                <path
                  fill-rule="evenodd"
                  d="M2 13.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1H3.707L13.854 2.854a.5.5 0 0 0-.708-.708L3 12.293V7.5a.5.5 0 0 0-1 0v6z"
                />
              </svg>
            </div>
            <div className="mx-16">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                fill="currentColor"
                class="bi bi-arrow-down-right"
                viewBox="0 0 16 16"
                style={{ color: "#666a6f" }}
              >
                <path
                  fill-rule="evenodd"
                  d="M14 13.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.793L2.146 2.854a.5.5 0 1 1 .708-.708L13 12.293V7.5a.5.5 0 0 1 1 0v6z"
                />
              </svg>
            </div>
          </div>
          <div className="grid grid-rows-2 grid-flow-col">
            <div className="row-span-0.25 col-span-0.25"></div>
            <div class="row-span-2 col-span-2 ">
              {" "}
              <span className="relative z-0 inline-flex shadow-sm rounded-md mt-4">
                <button
                  type="button"
                  className={
                    renvoidirect
                      ? "dark:text-gray-400 dark:bg-gray-600 relative inline-flex items-center px-4 py-2 rounded-md border border-gray-300  bg-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                      : "dark:text-white dark:bg-gray-700 relative inline-flex items-center px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  }
                >
                  {t("transfert.appel.conditional")}
                </button>
              </span>{" "}
              <div className="flex  ">
                <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="currentColor"
                    class="bi bi-arrow-down-left"
                    viewBox="0 0 16 16"
                    style={{ color: "#666a6f" }}
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2 13.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1H3.707L13.854 2.854a.5.5 0 0 0-.708-.708L3 12.293V7.5a.5.5 0 0 0-1 0v6z"
                    />
                  </svg>
                </div>
                <div className="mx-16">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="currentColor"
                    class="bi bi-arrow-down-right"
                    viewBox="0 0 16 16"
                    style={{ color: "#666a6f" }}
                  >
                    <path
                      fill-rule="evenodd"
                      d="M14 13.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.793L2.146 2.854a.5.5 0 1 1 .708-.708L13 12.293V7.5a.5.5 0 0 1 1 0v6z"
                    />
                  </svg>
                </div>
              </div>
              {/* <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 16"
                  fill="currentColor"
                  //viewBox="0 0 16 16"
                  //  className="h-32 w-32"
                >
                  <path
                    //  class="h-48 w-16"
                    fill-rule="evenodd"
                    d="M2 13.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1H3.707L13.854 2.854a.5.5 0 0 0-.708-.708L3 12.293V7.5a.5.5 0 0 0-1 0v6z"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 16"
                  fill="currentColor"
                  //viewBox="0 0 16 16"

                  className="-pl-32"
                >
                  <path
                    fill-rule="evenodd"
                    d="M14 13.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.793L2.146 2.854a.5.5 0 1 1 .708-.708L13 12.293V7.5a.5.5 0 0 1 1 0v6z"
                  />
                </svg>
              </div> */}
            </div>
            <div class="row-span-2 col-span-2 -ml-16">
              {" "}
              <span className="relative z-0 inline-flex shadow-sm rounded-md mt-4">
                <button
                  type="button"
                  className="dark:text-white dark:bg-gray-700 relative inline-flex items-center px-4 py-2 rounded-l-md border  border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                >
                  {t("transfert.appel.inconditional")}
                </button>
                {renvoidirect ? (
                  <div className="dark:text-white dark:bg-gray-700 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md br-none border border-left-white border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"></div>
                ) : (
                  <button
                    onClick={handleShowrenvoi}
                    type="button"
                    className="dark:text-white dark:bg-gray-700 dark:text-white dark:bg-gray-700 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    <PlusIcon
                      className="h-5 w-5 text-gray-400 dark:text-gray-200"
                      aria-hidden="true"
                    />
                  </button>
                )}
                <Renvoidirect
                  showModal={showModalrenvoi}
                  handleClose={handleCloserenvoi}
                  toggle={fetchData}
                  //updatesidebar={props.toggle()}
                />
              </span>
              {renvoidirect ? (
                <div className="pl-24">
                  {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  width="50"
                  height="50"
                  viewBox="0 0 256 256"
                >
                  <path
                    d="M 89 0 L 52.315 0 C 33.072 0 17.417 15.755 17.417 35.121 c 0 0.055 0.004 0.107 0.013 0.16 l 0 24.545 L 1 59.826 c -0.404 0 -0.768 0.243 -0.923 0.616 c -0.155 0.373 -0.071 0.803 0.214 1.09 l 28.002 28.186 c 0.376 0.377 1.043 0.377 1.419 0 l 28.002 -28.186 c 0.285 -0.287 0.369 -0.716 0.214 -1.09 c -0.154 -0.373 -0.519 -0.616 -0.923 -0.616 l -16.429 0 l 0 -24.705 c 0 -0.054 -0.004 -0.105 -0.012 -0.156 c 0.083 -6.455 5.323 -11.679 11.752 -11.679 l 36.685 0 c 0.553 0 1 -0.447 1 -1 L 90 1 C 90 0.447 89.553 0 89 0 z"
                    className="curvedarrow"
                    transform=" matrix(1 0 0 1 0 0) "
                    stroke-linecap="round"
                  />
                </svg> */}
                  <svg version="1.1" id="svg2" height="10" width="25">
                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.49181698 V 10.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                  </svg>
                  <svg version="1.1" id="svg2" height="10" width="25">
                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.59181698 V 18.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                  </svg>
                  <svg version="1.1" id="svg2" height="10" width="25">
                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.59181698 V 18.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                  </svg>
                  <svg version="1.1" id="svg2" height="10" width="25">
                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.59181698 V 18.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                  </svg>
                  <svg version="1.1" id="svg2" height="10" width="25">
                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.59181698 V 18.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                  </svg>
                  <svg version="1.1" id="svg2" height="25" width="25">
                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.59181698 V 18.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />

                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.59181698 V 18.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                    <path
                      stroke-miterlimit="100"
                      d="M 8.5338983,-0.59181698 V 18.343556"
                      id="imagebot_5"
                      className="arrowhanedi"
                      // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                    <path
                      stroke-miterlimit="4"
                      d="m 2.8478983,11.219014 5.686,7.124542"
                      id="imagebot_4"
                      className="arrow2"
                      //  style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                    <path
                      stroke-miterlimit="4"
                      d="M 14.219898,11.21914 8.5338983,18.343556"
                      id="imagebot_4-1"
                      className="arrow3"
                      //  style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                    />
                  </svg>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
          <div className="grid grid-rows-2 grid-flow-col gap-6 -ml-12">
            {/* <div className="grid grid-rows-2 grid-flow-col"> */}
            <div className="row-span-1 col-span-1 flex "></div>
            <div className="row-span-2 col-span-2 flex ">
              <div className=" ml-6">
                {" "}
                <span className=" inline-flex shadow-sm rounded-md mt-4 ">
                  <button
                    type="button"
                    className={
                      renvoidirect
                        ? "dark:text-gray-400 dark:bg-gray-600 relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-gray-300 text-sm font-medium text-gray-700  "
                        : "dark:text-white dark:bg-gray-700 relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    }
                  >
                    {t("transfert.appel.interne")}
                  </button>
                  {renvoiinterne || renvoidirect ? (
                    <div
                      className={
                        renvoidirect
                          ? "dark:text-white dark:bg-gray-700 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md br-none border border-left-white border-gray-300 bg-gray-300 text-sm font-medium text-gray-700 "
                          : "dark:text-white dark:bg-gray-700 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md br-none border border-left-white border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      }
                    ></div>
                  ) : (
                    <button
                      onClick={handleShow}
                      type="button"
                      className={
                        renvoidirect
                          ? "dark:text-gray-400 dark:bg-gray-600 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-gray-300 text-sm font-medium text-gray-700 "
                          : "dark:text-white dark:bg-gray-700 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      }
                    >
                      <PlusIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </button>
                  )}

                  <Modalchoix
                    showModal={showModal}
                    handleClose={handleClose}
                    toggle={fetchDatainterne}
                  />
                </span>
                {renvoiinterne ? (
                  <div className="pl-16">
                    <svg version="1.1" id="svg2" height="10" width="25">
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                    </svg>
                    <svg version="1.1" id="svg2" height="10" width="25">
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                    </svg>
                    <svg version="1.1" id="svg2" height="25" width="25">
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="4"
                        d="m 2.8478983,11.219014 5.686,7.124542"
                        id="imagebot_4"
                        className="arrow2"
                        //  style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="4"
                        d="M 14.219898,11.21914 8.5338983,18.343556"
                        id="imagebot_4-1"
                        className="arrow3"
                        //  style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                    </svg>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              <div class="ml-24">
                {" "}
                <span className="relative z-0 inline-flex shadow-sm rounded-md mt-4 ">
                  <button
                    type="button"
                    className={
                      renvoidirect
                        ? "dark:text-gray-400 dark:bg-gray-600 relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-gray-300 text-sm font-medium text-gray-700  "
                        : "dark:text-white dark:bg-gray-700 relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    }
                  >
                    {t("transfert.appel.Externe")}
                  </button>
                  {renvoiexterne || renvoidirect ? (
                    <div
                      className={
                        renvoidirect
                          ? "dark:text-gray-400 dark:bg-gray-600 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md br-none border border-left-white border-gray-300 bg-gray-300 text-sm font-medium text-gray-700 "
                          : "dark:text-white dark:bg-gray-700 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md br-none border border-left-white border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      }
                    ></div>
                  ) : (
                    <button
                      onClick={handleShowexterne}
                      type="button"
                      className="dark:text-white dark:bg-gray-700 -ml-px relative inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <PlusIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </button>
                  )}
                  <Modalchoixexterne
                    showModal={showModalexterne}
                    handleClose={handleCloseexterne}
                    toggle={fetchDataexterne}
                  />
                </span>
                {renvoiexterne ? (
                  <div className="pl-16">
                    <svg version="1.1" id="svg2" height="10" width="25">
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                    </svg>
                    <svg version="1.1" id="svg2" height="10" width="25">
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                    </svg>
                    <svg version="1.1" id="svg2" height="25" width="25">
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="100"
                        d="M 8.5338983,-0.59181698 V 18.343556"
                        id="imagebot_5"
                        className="arrowhanedi"
                        // style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="4"
                        d="m 2.8478983,11.219014 5.686,7.124542"
                        id="imagebot_4"
                        className="arrow2"
                        //  style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                      <path
                        stroke-miterlimit="4"
                        d="M 14.219898,11.21914 8.5338983,18.343556"
                        id="imagebot_4-1"
                        className="arrow3"
                        //  style="opacity:1;fill:#5f6368;fill-opacity:1;stroke:#5f6368;stroke-width:3.23161912;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1"
                      />
                    </svg>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>

            <div class="row-span-2 col-span-2">
              {renvoidirect ? (
                <div className="grid sm:grid-cols-2 lg:grid-cols-2 ml-8 ">
                  <div className=" dark:text-white dark:bg-gray-700 border border-gray-300 col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200 w-48 ">
                    <div className="w-full flex items-center justify-between p-6 space-x-6">
                      <div className="flex-1 truncate">
                        <div className="flex items-center space-x-3">
                          <span className="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full">
                            {" "}
                            Mobile
                          </span>
                          <h3 className="text-gray-900 text-sm font-medium truncate dark:text-white dark:bg-gray-700 ">
                            {renvoidirectnum}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="-mt-px flex divide-x divide-gray-200">
                        <div className="w-0 flex-1 flex">
                          <a className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-1 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                            <PencilIcon
                              className="w-4 h-4 text-gray-400"
                              aria-hidden="true"
                            />
                            <button
                              onClick={handleShoweditrenvoi}
                              className="ml-1 dark:text-white dark:bg-gray-700 "
                            >
                              {t("edit")}
                            </button>
                          </a>
                          <Editrenvoidirect
                            showModal={showeditModalrenvoi}
                            handleClose={handleCloseeditrenvoi}
                            numrenvoi={renvoidirectnum}
                            toggle={fetchData}
                          />
                        </div>
                        <div className="-ml-px w-0 flex-1 flex">
                          <a className="relative w-1 flex-1 inline-flex items-center justify-center py-1 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500">
                            <XCircleIcon
                              className="w-4 h-4 text-gray-400"
                              aria-hidden="true"
                            />
                            <button
                              onClick={handleShowdeleterenvoi}
                              className="ml-1 dark:text-white dark:bg-gray-700 "
                            >
                              {t("transfert.desactiver")}
                            </button>
                          </a>
                          <Deleterenvoidirect
                            showModal={showdeleteModalrenvoi}
                            handleClose={handleClosedeleterenvoi}
                            numrenvoi={renvoidirectnum}
                            toggle={fetchData}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="grid ml-4 gap-4 w-56 ml-56">
                  <div className="col-span-1  rounded-lg ">
                    <div className="w-full flex items-center justify-between p-6 space-x-6">
                      <div className="flex-1 truncate">
                        <div className="flex items-center space-x-3"></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div class="row-span-2 col-span-3 flex  ">
            {" "}
            <div className="row-span-3 col-span-3"></div>
            {renvoiinterne ? (
              <div className="grid ml-4 w-48 mr-8">
                <div
                  className={
                    renvoidirect
                      ? "bg-gray-300 dark:text-gray-400 dark:bg-gray-600 border border-gray-300 col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
                      : "dark:text-white dark:bg-gray-700 border border-gray-300 col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
                  }
                >
                  <div className="w-full flex items-center justify-between p-6 space-x-6">
                    <div className="flex-1 truncate">
                      <div className="flex items-center space-x-3">
                        <span className="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full">
                          {" "}
                          {renvoiinternetype}
                        </span>
                        <h3
                          className={
                            renvoidirect
                              ? "dark:text-gray-400 dark:bg-gray-600 text-gray-900 text-sm font-medium truncate"
                              : "dark:text-white dark:bg-gray-700 text-gray-900 text-sm font-medium truncate"
                          }
                        >
                          {renvoiinternenum}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="-mt-px flex divide-x divide-gray-200">
                      <div className="w-0 flex-1 flex">
                        <a className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-1 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                          <PencilIcon
                            className="w-4 h-4 text-gray-400"
                            aria-hidden="true"
                          />
                          <button
                            onClick={handleShowedit_renvoi_interne}
                            className={
                              renvoidirect
                                ? "ml-1 dark:text-gray-400 dark:bg-gray-600"
                                : "ml-1 dark:text-white dark:bg-gray-700"
                            }
                          >
                            {t("edit")}{" "}
                          </button>
                          <Editrenvoiinterne
                            showModal={showeditModal_renvoi_interne}
                            handleClose={handleCloseedit_renvoi_interne}
                            num={renvoiinternenum}
                            toggle={fetchDatainterne}
                            type={renvoiinternetype}
                            nbsonnerie={renvoiinternesonnerie}
                          />
                        </a>
                      </div>
                      <div className="-ml-px w-0 flex-1 flex">
                        <a className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-1 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                          <XCircleIcon
                            className="w-4 h-4 text-gray-400"
                            aria-hidden="true"
                          />
                          <button
                            onClick={handleShowdelete_renvoi_interne}
                            className={
                              renvoidirect
                                ? "ml-1 dark:text-gray-400 dark:bg-gray-600"
                                : "ml-1 dark:text-white dark:bg-gray-700"
                            }
                          >
                            {t("transfert.desactiver")}
                          </button>
                          <Deleterenvoiinterne
                            num={renvoiinternenum}
                            showModal={showdeleteModal_renvoi_interne}
                            handleClose={handleClosedelete_renvoi_interne}
                            toggle={fetchDatainterne}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid ml-4 gap-4 w-56">
                <div className="col-span-1  rounded-lg ">
                  <div className="w-full flex items-center justify-between p-6 space-x-6">
                    <div className="flex-1 truncate">
                      <div className="flex items-center space-x-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {renvoiexterne ? (
              <div className="grid gap-4 ml-4 w-48">
                <div
                  className={
                    renvoidirect
                      ? "bg-gray-300 dark:text-gray-300 dark:bg-gray-600 border border-gray-300 col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
                      : "dark:text-white dark:bg-gray-700 border border-gray-300 col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
                  }
                >
                  {" "}
                  <div className="w-full flex items-center justify-between p-6 space-x-6">
                    <div className="flex-1 truncate">
                      <div className="flex items-center space-x-3">
                        <span className="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full">
                          {renvoiexternetype}
                        </span>
                        <h3
                          className={
                            renvoidirect
                              ? "dark:text-gray-400 dark:bg-gray-600 text-gray-900 text-sm font-medium truncate"
                              : "dark:text-white dark:bg-gray-700 text-gray-900 text-sm font-medium truncate"
                          }
                        >
                          {renvoiexternenum}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="-mt-px flex divide-x divide-gray-200">
                      <div className="w-0 flex-1 flex">
                        <a className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-1 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                          <PencilIcon
                            className="w-4 h-4 text-gray-400"
                            aria-hidden="true"
                          />
                          <button
                            onClick={handleShowedit_renvoi_externe}
                            className={
                              renvoidirect
                                ? "ml-1 dark:text-gray-400 dark:bg-gray-600"
                                : "ml-1 dark:text-white dark:bg-gray-700"
                            }
                          >
                            {t("edit")}{" "}
                          </button>
                          <Editrenvoiexterne
                            showModal={showeditModal_renvoi_externe}
                            handleClose={handleCloseedit_renvoi_externe}
                            num={renvoiexternenum}
                            toggle={fetchDataexterne}
                            type={renvoiexternetype}
                            nbsonnerie={renvoiexternesonnerie}
                          />
                        </a>
                      </div>
                      <div className="-ml-px w-0 flex-1 flex">
                        <a className="relative w-0 flex-1 inline-flex items-center justify-center py-1 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500">
                          <XCircleIcon
                            className="w-4 h-4 text-gray-400"
                            aria-hidden="true"
                          />
                          <button
                            onClick={handleShowdelete_renvoi_externe}
                            className={
                              renvoidirect
                                ? "ml-1 dark:text-gray-400 dark:bg-gray-600"
                                : "ml-1 dark:text-white dark:bg-gray-700"
                            }
                          >
                            {t("transfert.desactiver")}
                          </button>
                          <Deleterenvoiexterne
                            num={renvoiexternenum}
                            showModal={showdeleteModal_renvoi_externe}
                            handleClose={handleClosedelete_renvoi_externe}
                            toggle={fetchDataexterne}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid ml-4  w-56">
                <div className="col-span-1  rounded-lg ">
                  <div className="w-full flex items-center justify-between p-6 space-x-6">
                    <div className="flex-1 truncate">
                      <div className="flex items-center space-x-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default withTranslation("common")(Profile2);
